import { ROUTE_INDEX_NEXT_STEPS, ROUTE_NAME_NEXT_STEPS, ROUTE_NAME_PERSONS } from '@/config/constants'

export default [
  {
    beforeEnter(_to, from, next) {
      // refresh
      if (from.name === null) {
        next({ name: ROUTE_NAME_PERSONS })
        // normal entry to route
      } else {
        next()
      }
    },
    component: () => import(/* webpackChunkName: "screen-nextsteps" */ '@/modules/Configurator/screens/NextSteps.vue'),
    meta: {
      disableNavigation: true,
      index: ROUTE_INDEX_NEXT_STEPS,
      navigation: false,
      secured: false,
    },
    name: ROUTE_NAME_NEXT_STEPS,
    path: '/next-steps',
  },
]
